export const PRES = {
  textPrimary: '#14161c',
  textSecondary: '#5b616e',
  textTertiary: '#767d8a',
  borderSubtle: '#e3e5ea',
  borderStrong: '#c9cdd6',
  surface: '#ffffff',
  surfaceRaised: '#ffffff',
  surfaceSunken: '#f6f7f9',
  canvas: '#eef0f3',
  interactive: '#0A2757',
  interactiveHover: '#071c3d',
  focusRing: '#245dc1',
  danger: '#b42318',
  warn: '#9a6700',
  navy: '#0A2757',
  navyDeep: '#071c3d',
  navyMid: '#122f5f',
  gold: '#C4A35A',
  guide: '#C23B32',
  cream: '#f6f7f9',
  white: '#ffffff',
  line: '#e3e5ea',
  muted: '#5b616e',
} as const;

export const TYPE = {
  ui: 'Inter, "Segoe UI", Arial, sans-serif',
  tabular: '"IBM Plex Mono", ui-monospace, "Segoe UI", Consolas, monospace',
  title: { fontSize: 16, fontWeight: 650, lineHeight: 1.25, letterSpacing: '-0.01em' },
  section: { fontSize: 11, fontWeight: 650, lineHeight: 1.3, letterSpacing: '0.04em' },
  body: { fontSize: 13, fontWeight: 450, lineHeight: 1.4 },
  label: { fontSize: 12, fontWeight: 500, lineHeight: 1.3 },
  meta: { fontSize: 12, fontWeight: 450, lineHeight: 1.3 },
  caption: { fontSize: 11, fontWeight: 500, lineHeight: 1.3 },
} as const;

export const SPACE = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
} as const;

export const CONTROL = {
  height: 32,
  row: 40,
  radius: 6,
  radiusCard: 8,
} as const;

export const MOTION = {
  hover: '120ms ease',
  panel: '180ms ease',
  reduced: '0ms',
} as const;

export const ELEVATION = {
  none: 'none',
  cardHover: '0 1px 2px rgba(20, 22, 28, 0.06), 0 8px 20px rgba(20, 22, 28, 0.06)',
  flyout: '0 8px 28px rgba(20, 22, 28, 0.16)',
} as const;

export const CONTROL_STATE = {
  hoverBg: PRES.surfaceSunken,
  pressedBg: PRES.borderSubtle,
  selectedFg: PRES.interactive,
  selectedBg: PRES.surfaceSunken,
  disabledOpacity: 0.45,
  errorFg: PRES.danger,
} as const;

export const focusRingSx = {
  outline: 'none',
  boxShadow: `0 0 0 2px ${PRES.surface}, 0 0 0 4px ${PRES.focusRing}`,
} as const;

export const interactiveResetSx = {
  fontFamily: TYPE.ui,
  appearance: 'none',
  border: 'none',
  background: 'transparent',
  padding: 0,
  margin: 0,
  color: 'inherit',
} as const;
